<div class="page">
  <div class="page-head">
    <div>
      <h2>{{ pageTitle() || 'Find Certificate' }}</h2>
      <p>Look up a Certificate of Insurance by its Policy/Certificate No or Member Id.</p>
    </div>
  </div>

  <div class="card search-card">
    <div class="search-row">
      <div class="field key-field">
        <label>Search by</label>
        <p-select [options]="keyOptions" optionLabel="label" optionValue="value"
          [ngModel]="key()" (ngModelChange)="key.set($event); foundMemberId.set(null)" appendTo="body" />
      </div>
      <div class="field term-field">
        <label>Certificate / Policy No · Member Id</label>
        <input pInputText type="text" [ngModel]="term()" (ngModelChange)="term.set($event)"
          [placeholder]="placeholder" (keyup.enter)="find()" />
      </div>
      <div class="search-actions">
        <p-button label="Find" icon="pi pi-search" [loading]="searching()" (onClick)="find()" />
        <p-button label="Clear" icon="pi pi-times" [outlined]="true" (onClick)="clear()" />
      </div>
    </div>
  </div>

  <div class="card result-card">
    @if (foundMemberId()) {
      <app-coi-view [memberId]="foundMemberId()" />
    } @else if (searching()) {
      <div class="state"><i class="pi pi-spin pi-spinner"></i><p>Searching…</p></div>
    } @else if (searched()) {
      <div class="state"><i class="pi pi-file-excel"></i><p>No certificate found for that reference.</p></div>
    } @else {
      <div class="state"><i class="pi pi-verified"></i><p>Enter a certificate no or member id above to find a certificate.</p></div>
    }
  </div>
</div>
